<template>
  <header class="header">
    <button class="menu-btn" @click="navStore.toggleSidebar">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    </button>

    <div class="search-wrapper">
      <div class="search-box" @click="openCommandPalette">
        <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"/>
          <path d="M21 21l-4.35-4.35"/>
        </svg>
        <span class="search-placeholder">搜索网站、工具或使用AI...</span>
        <div class="search-shortcut">
          <kbd>⌘</kbd>
          <kbd>K</kbd>
        </div>
      </div>
    </div>

    <div class="header-actions">
      <button class="action-btn" @click="openAIAssistant" title="AI助手">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2a4 4 0 014 4v1a3 3 0 013 3v1a3 3 0 01-1 2.24V16a4 4 0 01-4 4h-4a4 4 0 01-4-4v-2.76A3 3 0 015 11v-1a3 3 0 013-3V6a4 4 0 014-4z"/>
        </svg>
      </button>

      <button class="action-btn" @click="navStore.toggleTheme" title="切换主题">
        <svg v-if="navStore.theme === 'dark'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/>
          <line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/>
          <line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
        </svg>
      </button>

      <button class="action-btn" @click="showAddModal = true" title="添加书签">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>
    </div>

    <AddBookmarkModal v-if="showAddModal" @close="showAddModal = false" />
  </header>
</template>

<script setup>
import { ref, inject } from 'vue'
import { useNavStore } from '@/stores/nav'
import AddBookmarkModal from './AddBookmarkModal.vue'

const navStore = useNavStore()
const showAddModal = ref(false)

const openCommandPalette = inject('openCommandPalette', () => {})
const openAIAssistant = inject('openAIAssistant', () => {})
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-md) 0;
  margin-bottom: var(--spacing-lg);
}

.menu-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
  
  svg {
    width: 24px;
    height: 24px;
    color: var(--text-secondary);
  }
  
  &:hover {
    background: var(--bg-hover);
  }
  
  @media (min-width: 1025px) {
    display: none;
  }
}

.search-wrapper {
  flex: 1;
  max-width: 600px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-fast);
  
  &:hover {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
}

.search-icon {
  width: 20px;
  height: 20px;
  color: var(--text-muted);
}

.search-placeholder {
  flex: 1;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.search-shortcut {
  display: flex;
  gap: 4px;
  
  kbd {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 6px;
    background: var(--bg-tertiary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    font-size: var(--text-xs);
    font-family: var(--font-sans);
    color: var(--text-muted);
  }
  
  @media (max-width: 640px) {
    display: none;
  }
}

.header-actions {
  display: flex;
  gap: var(--spacing-xs);
}

.action-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  transition: all var(--transition-fast);
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  &:hover {
    background: var(--bg-hover);
    color: var(--text-primary);
  }
}
</style>
